(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecommerce-header"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const MIN_QUERY_LENGTH = 2;
      const MAX_RESULTS = 8;

      const normalize = (value) =>
        String(value || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();

      const getSectionId = (form) => {
        const wrapper = form.closest('.shopify-section');
        if (!wrapper) return null;
        return wrapper.id.replace('shopify-section-', '');
      };

      const readJsonData = (id, fallbackMessage) => {
        const dataEl = document.getElementById(id);

        if (!dataEl) return [];

        try {
          const parsed = JSON.parse(dataEl.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.warn(fallbackMessage, error);
          return [];
        }
      };

      const getModels = (form) => {
        const sectionId = getSectionId(form);
        if (!sectionId) return [];

        return readJsonData(
          `CameraModelData-${sectionId}`,
          'Impossibile leggere i modelli camera:'
        );
      };

      const getBrands = (form) => {
        const sectionId = getSectionId(form);
        if (!sectionId) return [];

        return readJsonData(
          `CameraBrandData-${sectionId}`,
          'Impossibile leggere i brand fotocamera:'
        );
      };

      const findMatches = (models, query) => {
        const normalizedQuery = normalize(query);

        if (normalizedQuery.length < MIN_QUERY_LENGTH) return [];

        return models
          .map((model) => {
            const label = normalize(model.label);
            const brand = normalize(model.brand);
            const terms = normalize(model.terms);
            const haystack = `${label} ${brand} ${terms}`;

            let score = 0;

            if (label === normalizedQuery) score += 100;
            if (label.startsWith(normalizedQuery)) score += 60;
            if (haystack.includes(normalizedQuery)) score += 30;

            return {
              ...model,
              score,
            };
          })
          .filter((model) => model.score > 0)
          .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label))
          .slice(0, MAX_RESULTS);
      };

      const hideSuggestions = (form) => {
        const input = form.querySelector('[data-camera-model-input]');
        const suggestions = form.querySelector('[data-camera-model-suggestions]');
        const header = form.closest('[data-site-header]');

        if (suggestions) {
          suggestions.hidden = true;
          suggestions.innerHTML = '';
        }

        if (input) {
          input.setAttribute('aria-expanded', 'false');
        }

        if (header) {
          header.classList.remove('is-model-search-open');
        }
      };

      const goToModel = (model) => {
        if (!model || !model.url) return;
        window.location.href = model.url;
      };

      const renderSuggestions = (form, items, emptyMessage = 'Nessun risultato trovato') => {
        const input = form.querySelector('[data-camera-model-input]');
        const suggestions = form.querySelector('[data-camera-model-suggestions]');
        const header = form.closest('[data-site-header]');

        if (!input || !suggestions) return;

        const matches = findMatches(items, input.value);

        suggestions.innerHTML = '';

        if (matches.length === 0) {
          if (input.value.trim().length >= MIN_QUERY_LENGTH) {
            const empty = document.createElement('div');
            empty.className = 'site-header__model-empty';
            empty.textContent = emptyMessage;
            suggestions.appendChild(empty);
            suggestions.hidden = false;
            input.setAttribute('aria-expanded', 'true');

            if (header) {
              header.classList.add('is-model-search-open');
            }
          } else {
            hideSuggestions(form);
          }

          return;
        }

        for (const model of matches) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'site-header__model-suggestion';
          button.setAttribute('role', 'option');

          const name = document.createElement('span');
          name.className = 'site-header__model-suggestion-name';
          name.textContent = model.label;

          const brand = document.createElement('span');
          brand.className = 'site-header__model-suggestion-brand';
          brand.textContent = model.brand ? `Marca: ${model.brand}` : model.typeLabel || 'Risultato';

          button.append(name, brand);

          button.addEventListener('click', () => {
            input.value = model.label;
            goToModel(model);
          });

          suggestions.appendChild(button);
        }

        suggestions.hidden = false;
        input.setAttribute('aria-expanded', 'true');

        if (header) {
          header.classList.add('is-model-search-open');
        }
      };

      const setMode = (form, mode) => {
        const input = form.querySelector('[data-camera-model-input]');
        const modeSelect = form.querySelector('[data-search-mode-select]');

        form.dataset.searchMode = mode;

        if (modeSelect) {
          modeSelect.value = mode;
        }

        if (input) {
          const genericPlaceholder = input.dataset.genericPlaceholder || 'Cerca prodotto, categoria, marca...';
          const modelPlaceholder = input.dataset.modelPlaceholder || 'Cerca modello camera...';
          const brandPlaceholder = 'Cerca marca fotocamera...';

          if (mode === 'model') {
            input.placeholder = modelPlaceholder;
          } else if (mode === 'brand') {
            input.placeholder = brandPlaceholder;
          } else {
            input.placeholder = genericPlaceholder;
          }
          input.value = '';
          input.focus();
        }

        hideSuggestions(form);

        const header = form.closest('[data-site-header]');
        if (header) {
          header.classList.remove('is-model-search-open');
        }
      };

      const setupForm = (form) => {
        if (form.dataset.cameraModelSearchReady === 'true') return;

        form.dataset.cameraModelSearchReady = 'true';

        const models = getModels(form).map((item) => ({
          ...item,
          typeLabel: 'Modello camera',
        }));
        const brands = getBrands(form).map((item) => ({
          ...item,
          typeLabel: 'Collezione marca',
        }));
        const input = form.querySelector('[data-camera-model-input]');
        const modeSelect = form.querySelector('[data-search-mode-select]');

        if (modeSelect) {
          modeSelect.addEventListener('change', () => {
            setMode(form, modeSelect.value || 'generic');
          });
        }

        if (input) {
          input.addEventListener('input', () => {
            if (form.dataset.searchMode === 'model') {
              renderSuggestions(form, models, 'Nessun modello trovato');
              return;
            }

            if (form.dataset.searchMode === 'brand') {
              renderSuggestions(form, brands, 'Nessuna marca trovata');
            }
          });

          input.addEventListener('keydown', (event) => {
            if (form.dataset.searchMode !== 'model') return;

            const suggestions = form.querySelector('[data-camera-model-suggestions]');
            const options = suggestions ? Array.from(suggestions.querySelectorAll('.site-header__model-suggestion')) : [];
            const activeIndex = options.findIndex((option) => option.classList.contains('is-active'));

            if (event.key === 'Escape') {
              hideSuggestions(form);
              return;
            }

            if (!options.length) return;

            if (event.key === 'ArrowDown') {
              event.preventDefault();
              const nextIndex = activeIndex >= options.length - 1 ? 0 : activeIndex + 1;
              options.forEach((option) => option.classList.remove('is-active'));
              options[nextIndex].classList.add('is-active');
              options[nextIndex].scrollIntoView({ block: 'nearest' });
            }

            if (event.key === 'ArrowUp') {
              event.preventDefault();
              const nextIndex = activeIndex <= 0 ? options.length - 1 : activeIndex - 1;
              options.forEach((option) => option.classList.remove('is-active'));
              options[nextIndex].classList.add('is-active');
              options[nextIndex].scrollIntoView({ block: 'nearest' });
            }

            if (event.key === 'Enter' && activeIndex >= 0) {
              event.preventDefault();
              options[activeIndex].click();
            }
          });
        }

        form.addEventListener('submit', (event) => {
          if (form.dataset.searchMode !== 'model' && form.dataset.searchMode !== 'brand') return;

          const query = input ? input.value.trim() : '';
          const source = form.dataset.searchMode === 'brand' ? brands : models;
          const matches = findMatches(source, query);

          if (matches.length > 0) {
            event.preventDefault();
            goToModel(matches[0]);
          }
        });

        document.addEventListener('click', (event) => {
          if (!form.contains(event.target)) {
            hideSuggestions(form);
          }
        });
      };

      const init = () => {
        document.querySelectorAll('[data-camera-model-search]').forEach(setupForm);
      };

      init();

      document.addEventListener('shopify:section:load', init);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
